import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Button from '@SiteComponents/Button'
import Close from '@Images/bulk_action_bar_close.svg'
import Delete from '@Images/bulk_action_bar_delete.svg'

import {
  resetSelectedSpeakerVoices,
} from '@SiteModules/SpeakerVoice/actions'

import {
  openRemoveSpeakerVoicePopup,
} from '@SiteModules/Popup/actions'

import {
  getSelectedIds,
} from '@SiteModules/SpeakerVoice/selectors'

import './SpeakerVoicesBulkActionBar.scss'

const BAR_WIDTH = 500 // px, as in SpeakerVoicesBulkActionBar width

const SpeakerVoicesBulkActionBar: React.FC = () => {
  const dispatch = useDispatch()

  const selectedSpeakerVoicesIds = useSelector(getSelectedIds)

  const numberOfSelectedSpeakerVoices = selectedSpeakerVoicesIds.length

  const tableElement = document.getElementsByClassName('SpeakerVoicesTable')[0] as HTMLDivElement | undefined
  const sidebarElement = document.getElementsByClassName('Sidebar')[0] as HTMLDivElement | undefined

  const tableWidth = tableElement?.offsetWidth || 0
  const sidebarWidth = sidebarElement?.offsetWidth || 0

  const style = {
    left: `${sidebarWidth + 0.5 * (tableWidth - BAR_WIDTH)}px`,
  }

  useEffect(() => {
    if (!tableElement || !sidebarElement) {
      handleClose()
    }
  }, [])

  const handleClose = () => {
    dispatch(resetSelectedSpeakerVoices())
  }

  const handleRemove = () => {
    dispatch(openRemoveSpeakerVoicePopup({ speakerVoiceIds: selectedSpeakerVoicesIds }))
  }

  const renderRemove = () => {
    return (
      <Button
        caption="Remove"
        icon={<Delete />}
        styleType="danger"
        size="small"
        onClick={handleRemove}
      />
    )
  }

  return (
    <div
      className="SpeakerVoicesBulkActionBar"
      style={style}
    >
      <div className="SpeakerVoicesBulkActionBar__left">
        <Close
          onClick={handleClose}
        />
        <div className="SpeakerVoicesBulkActionBar__selected">
          {numberOfSelectedSpeakerVoices === 1 ? '1 voice selected' : `${numberOfSelectedSpeakerVoices} voices selected`}
        </div>
      </div>
      <div className="SpeakerVoicesBulkActionBar__right">
        {renderRemove()}
      </div>
    </div>
  )
}

export default SpeakerVoicesBulkActionBar
